export const adobeAnalyticsBaseUrl = 'https://assets.adobedtm.com/94681dff8245/1a0a93d31f4f/';

export const adobeAnalytiesUseYn = 'Y';
